/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonPersonidResumeeExams200,
  GetApiV1PersonPersonidResumeeExams400,
  GetApiV1PersonPersonidResumeeExams401,
  GetApiV1PersonPersonidResumeeExams500,
  GetApiV1PersonPersonidResumeeExamsPathParams,
  GetApiV1PersonPersonidResumeeExamsQueryResponse,
} from "../../types/personResumeeController/GetApiV1PersonPersonidResumeeExams.ts";
import { studentResumeeExamsTabViewModelSchema } from "../studentResumeeExamsTabViewModelSchema.ts";

export const getApiV1PersonPersonidResumeeExamsPathParamsSchema = z.object({
  personId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1PersonPersonidResumeeExamsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonPersonidResumeeExams200Schema = z.lazy(
  () => studentResumeeExamsTabViewModelSchema,
) as unknown as ToZod<GetApiV1PersonPersonidResumeeExams200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1PersonPersonidResumeeExams400Schema =
  z.any() as unknown as ToZod<GetApiV1PersonPersonidResumeeExams400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonPersonidResumeeExams401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonPersonidResumeeExams401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonPersonidResumeeExams500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonPersonidResumeeExams500>;

export const getApiV1PersonPersonidResumeeExamsQueryResponseSchema = z.lazy(
  () => getApiV1PersonPersonidResumeeExams200Schema,
) as unknown as ToZod<GetApiV1PersonPersonidResumeeExamsQueryResponse>;
